import { hasValue, toObjectByIndex } from '@util';
import * as R from 'ramda';

export interface PcsValidationError {
  invalid: boolean;
  valid: boolean;
  message: string;
  params?: { [key: string]: string };
}

export interface PcsValidationErrors {
  [key: string]: PcsValidationError;
}

export const createValidationErrorObject = (message: string, params?: string[]): PcsValidationError => ({
  invalid: true,
  valid: false,
  message,
  params: R.ifElse(hasValue, toObjectByIndex, R.identity)(params)
});

export const createValidationError = (key: string, message: string, params?: string[]): PcsValidationErrors => ({
  [key]: createValidationErrorObject(message, params)
});
